<template>
	<v-slide-item>
		<template v-if="$_umSldItm_currentUser()">
			<v-btn	class="customVBtn mr-2"
					:block="$_umSldItm_styleMenuButtonBlock"
					:color="$_umSldItm_styleMenuButtonColor"
					:dark="$_umSldItm_styleMenuButtonDark"
					:depressed="$_umSldItm_styleMenuButtonDepressed"
					:elevation="$_umSldItm_styleMenuButtonElevation"
					:large="$_umSldItm_styleMenuButtonLarge"
					:light="$_umSldItm_styleMenuButtonLight"
					:outlined="$_umSldItm_styleMenuButtonOutlined"
					:rounded="$_umSldItm_styleMenuButtonRounded"
					:small="$_umSldItm_styleMenuButtonSmall"
					:text="$_umSldItm_styleMenuButtonFlat"
					@click="$_umSldItm_toggleTabs('user')">
				<v-row no-gutters align="center">
					<v-col class="center">
						<v-icon>face</v-icon>
					</v-col>
					<v-col class="ml-2 center">
						<span	class="overline" 
								v-html="$_umSldItm_stateUserFullName" />
					</v-col>
				</v-row>
			</v-btn>
		</template>
		<template v-else>
			<v-menu	close-delay
					offset-y
					:dark="$_umSldItm_styleCollapsedMenuDark"
					:light="$_umSldItm_styleCollapsedMenuLight">
				<template v-slot:activator="{ on }">
					<v-btn	class="customVBtn mr-2"
							:block="$_umSldItm_styleMenuButtonBlock"
							:color="$_umSldItm_styleMenuButtonColor"
							:dark="$_umSldItm_styleMenuButtonDark"
							:depressed="$_umSldItm_styleMenuButtonDepressed"
							:elevation="$_umSldItm_styleMenuButtonElevation"
							:large="$_umSldItm_styleMenuButtonLarge"
							:light="$_umSldItm_styleMenuButtonLight"
							:outlined="$_umSldItm_styleMenuButtonOutlined"
							:rounded="$_umSldItm_styleMenuButtonRounded"
							:small="$_umSldItm_styleMenuButtonSmall"
							:text="$_umSldItm_styleMenuButtonFlat"
							v-on="on">
						<v-row no-gutters align="center">
							<v-col class="center mr-2">
								<v-icon	:color="contents.user.iconColor"
										v-text="contents.user.icon || 'arrow_drop_down'" />
							</v-col>
							<v-col class="center">
								<span	class="overline"
										v-html="$_umSldItm_langContentTitle(contents.user)" />
							</v-col>
						</v-row>
					</v-btn>
				</template>
				<v-list>
					<template v-for="(menuItemVals, menuItemKey) in sortObject($_umSldItm_appMenuItemsContentsIsCollapsedMenu, 'order')">
						<template v-if="$_umSldItm_checkMenu(menuItemVals, 'user') && checkMenuGroup(menuItemVals.menuGroup) && checkSecurityGroup(menuItemVals.securityGroup)">
							<v-btn	:key="menuItemKey"

									class="customVBtn button_"

									:block="$_umSldItm_styleCollapsedMenuButtonBlock"
									:color="$_umSldItm_styleCollapsedMenuButtonColor"
									:dark="$_umSldItm_styleCollapsedMenuButtonDark"
									:depressed="$_umSldItm_styleCollapsedMenuButtonDepressed"
									:elevation="$_umSldItm_styleCollapsedMenuButtonElevation"
									:large="$_umSldItm_styleCollapsedMenuButtonLarge"
									:light="$_umSldItm_styleCollapsedMenuButtonLight"
									:outlined="$_umSldItm_styleCollapsedMenuButtonOutlined"
									:rounded="$_umSldItm_styleCollapsedMenuButtonRounded"
									:small="$_umSldItm_styleCollapsedMenuButtonSmall"
									:text="$_umSldItm_styleCollapsedMenuButtonFlat"
									:tile="$_umSldItm_styleCollapsedMenuButtonTile"

									@click="openLink(menuItemVals.link)">
								<v-row dense align="center">
									<template v-if="menuItemVals.icon">
										<v-col class="center" cols="auto">
											<v-icon :color="menuItemVals.iconColor"
													v-text="menuItemVals.icon" />
										</v-col>
									</template>
									<v-col class="center" cols="auto">
										<span	class="overline" 
												v-html="$_umSldItm_langAppMenuTitle(menuItemVals)" />
									</v-col>
									<template v-if="debugMode">
										<v-spacer />
										<v-col cols="auto">
											<debugger-order-alert :order="menuItemVals.order" />
										</v-col>
									</template>
								</v-row>
							</v-btn>
						</template>
					</template>
				</v-list>
			</v-menu>
		</template>
	</v-slide-item>
</template>

<script>
	export default {
		name: 'UserMenuSlideItem',
		props: {
			contentKey: String,
			contents: Object,
			inits: Object
		},
		computed: {
			// current user
			$_umSldItm_currentUser() {
				const self_ = this;
				return () => {
					return self_.getCurrentUser()
				}
			},
			// state
			$_umSldItm_stateUserFullName() {
				const self_ = this;
				return self_.getUserState('fullName')
			},
			// app menu items
			$_umSldItm_appMenuItemsContents() {
				const self_ = this;
				const contents_ = self_.getAppContents('menuItems')
				return self_.getContentsSubset(contents_, 'isDummy', false)
			},
			$_umSldItm_appMenuItemsContentsIsCollapsedMenu() {
				const self_ = this;
				const menuItems_ = self_.$_umSldItm_appMenuItemsContents;
				if(self_.isEmpty(menuItems_)) { return null }
				return self_.getContentsSubset(menuItems_, 'isCollapsedMenu', true)
			},
			$_umSldItm_langAppMenuTitle() {
				const self_ = this;
				return menuItemVals => {
					if(self_.isFalse(menuItemVals.title)) { return null }
					return self_.getLangsVal(menuItemVals.title)
				}
			},
			// lang
			$_umSldItm_langContentTitle() {
				const self_ = this;
				return menuItemVals => {
					const title_ = menuItemVals.title;
					if(self_.isFalse(title_)) { return null }
					return self_.getLangsVal(title_)
				}				
			},
			// style
			$_umSldItm_styleCollapsedMenu() {
				const self_ = this;
				if(self_.isEmpty(self_.inits)) { return null }
				return self_.getInitsStyleVal(self_.inits, 'collapsedMenu')
			},
			$_umSldItm_styleCollapsedMenuDark() {
				const self_ = this;
				const menu_ = self_.$_umSldItm_styleCollapsedMenu;
				if(self_.isFalse(menu_)) { return null }
				return self_.getStylesVal(menu_.dark)
			},
			$_umSldItm_styleCollapsedMenuLight() {
				const self_ = this;
				const menu_ = self_.$_umSldItm_styleCollapsedMenu;
				if(self_.isFalse(menu_)) { return null }
				return self_.getStylesVal(menu_.light)
			},
			$_umSldItm_styleMenuButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'menuButton')
			},
			$_umSldItm_styleMenuButtonBlock() {
				const self_ = this;
				const button_ = self_.$_umSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_umSldItm_styleMenuButtonColor() {
				const self_ = this;
				const button_ =self_.$_umSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_umSldItm_styleMenuButtonDark() {
				const self_ = this;
				const button_ = self_.$_umSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_umSldItm_styleMenuButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_umSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_umSldItm_styleMenuButtonElevation() {
				const self_ = this;
				const button_ = self_.$_umSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_umSldItm_styleMenuButtonFlat() {
				const self_ = this;
				const button_ = self_.$_umSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_umSldItm_styleMenuButtonLarge() {
				const self_ = this;
				const button_ = self_.$_umSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_umSldItm_styleMenuButtonLight() {
				const self_ = this;
				const button_ = self_.$_umSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_umSldItm_styleMenuButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_umSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_umSldItm_styleMenuButtonRounded() {
				const self_ = this;
				const button_ = self_.$_umSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_umSldItm_styleMenuButtonSmall() {
				const self_ = this;
				const button_ = self_.$_umSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_umSldItm_styleMenuButtonTile() {
				const self_ = this;
				const button_ = self_.$_umSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.tile)
			},
			$_umSldItm_styleCollapsedMenuButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'collapsedMenuButton')
			},
			$_umSldItm_styleCollapsedMenuButtonBlock() {
				const self_ = this;
				const button_ = self_.$_umSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_umSldItm_styleCollapsedMenuButtonColor() {
				const self_ = this;
				const button_ =self_.$_umSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_umSldItm_styleCollapsedMenuButtonDark() {
				const self_ = this;
				const button_ = self_.$_umSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_umSldItm_styleCollapsedMenuButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_umSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_umSldItm_styleCollapsedMenuButtonElevation() {
				const self_ = this;
				const button_ = self_.$_umSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_umSldItm_styleCollapsedMenuButtonFlat() {
				const self_ = this;
				const button_ = self_.$_umSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_umSldItm_styleCollapsedMenuButtonLarge() {
				const self_ = this;
				const button_ = self_.$_umSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_umSldItm_styleCollapsedMenuButtonLight() {
				const self_ = this;
				const button_ = self_.$_umSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_umSldItm_styleCollapsedMenuButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_umSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_umSldItm_styleCollapsedMenuButtonRounded() {
				const self_ = this;
				const button_ = self_.$_umSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_umSldItm_styleCollapsedMenuButtonSmall() {
				const self_ = this;
				const button_ = self_.$_umSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_umSldItm_styleCollapsedMenuButtonTile() {
				const self_ = this;
				const button_ = self_.$_umSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.tile)
			}
		},
		methods: {
			$_umSldItm_checkMenu(menu, key) {
				const self_ = this;
				if(self_.isEmpty(menu.menu)) { return false }
				return menu.menu[key]
			},
			$_umSldItm_toggleTabs(menu) {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				const toolbar_ = self_.getComponentState('toolbar')
				const showTabMenu_ = self_.getComponentState('showToolbarTabs')

				if(self_.isFalse(showTabMenu_)) {
					toolbar_.menu = menu;
					self_.setComponentState('toolbar', toolbar_)
					self_.setComponentState('showToolbarTabs', true)
				} else {
					if(toolbar_.menu != menu) {
						toolbar_.menu = menu;
						self_.setComponentState('toolbar', toolbar_)
					} else {
						self_.setComponentState('showToolbarTabs', false)
					}
				}

				vuetify_.goTo('#_app_top')
			}
		}
	}
</script>

<style scoped>
	.button_ {
		width: 100%;
		text-align: left;
	}
	.v-menu__content {
		max-width: 35% !important;
	}
</style>
